import { formatCurrency } from "@/components/pcp";
import { BdmBrand, bdmVars } from "@/components/comercial/BdmBrand";

const fmt = (n, d = 2) => (n || 0).toLocaleString("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d });
const fmtDate = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "—");
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x.toISOString().slice(0, 10); };

export function PropostaDocumento({ numero, dataEmissao, emp, contratante, tipo, objeto, validadeDias, prazoExecucao, condicoesPagamento, observacoes, apresentacao, responsavel, itens, rodape }) {
  let n = 1;
  const base = dataEmissao || new Date().toISOString().slice(0, 10);
  const lista = itens || [];
  const porCat = lista.reduce((acc, i) => { (acc[i.categoria || "Outros"] ||= []).push(i); return acc; }, {});
  const total = lista.reduce((s, i) => s + (i.valor_total ?? (i.qtd_contratada || 0) * (i.preco_unitario || 0)), 0);
  return (
    <div className="bdm-doc" data-testid="proposta-doc" style={bdmVars(emp)}>
      <div className="bdm-header">
        <BdmBrand emp={emp} fallbackSub="Sinalização Viária" />
        <div className="bdm-title">
          <h1>PROPOSTA COMERCIAL</h1>
          <div className="bdm-os-num" data-testid="proposta-doc-numero">Proposta nº {numero} · {fmtDate(base)}</div>
          {rodape && <div style={{ fontSize: "0.7rem", color: "#71717A" }}>{rodape}</div>}
        </div>
      </div>
      <table className="bdm-info-table">
        <tbody>
          <tr><th>Cliente</th><td>{contratante}</td><th>Tipo</th><td>{tipo}</td></tr>
          <tr><th>Objeto</th><td colSpan={3}>{objeto || "—"}</td></tr>
          <tr><th>Validade</th><td data-testid="prop-validade-ate">{validadeDias} dias (até {fmtDate(addDays(base, parseInt(validadeDias) || 30))})</td><th>Prazo execução</th><td>{prazoExecucao || "—"}</td></tr>
          <tr><th>Pagamento</th><td colSpan={3}>{condicoesPagamento || "—"}</td></tr>
        </tbody>
      </table>
      {apresentacao && (<><h2 className="bdm-h2">{n++}. Apresentação da Proposta</h2><p style={{ fontSize: "0.85rem", whiteSpace: "pre-wrap" }} data-testid="proposta-apresentacao">{apresentacao}</p></>)}
      <h2 className="bdm-h2">{n++}. Planilha de Serviços e Preços</h2>
      <table className="bdm-table" data-testid="proposta-itens">
        <thead><tr><th>Item</th><th>Descrição</th><th>Un</th><th style={{ textAlign: "right" }}>Quantidade</th><th style={{ textAlign: "right" }}>Preço unit.</th><th style={{ textAlign: "right" }}>Total</th></tr></thead>
        <tbody>
          {Object.entries(porCat).map(([cat, its]) => <Cat key={cat} cat={cat} itens={its} />)}
          <tr className="bdm-total-row"><td colSpan={5}><strong>VALOR TOTAL DA PROPOSTA</strong></td><td style={{ textAlign: "right" }} className="mono" data-testid="proposta-total"><strong>{formatCurrency(total)}</strong></td></tr>
        </tbody>
      </table>
      {observacoes && (<><h2 className="bdm-h2">{n++}. Observações / Condições Especiais</h2><p style={{ fontSize: "0.85rem", whiteSpace: "pre-wrap" }}>{observacoes}</p></>)}
      <div className="bdm-assinaturas">
        <div className="bdm-assinatura"><div className="bdm-linha-ass" /><strong>{responsavel?.nome || emp?.razao_social || emp?.nome || "Proponente"}</strong><br /><span style={{ color: "#71717A", fontSize: "0.72rem" }}>{[responsavel?.cargo || "Responsável comercial", emp?.razao_social || emp?.nome].filter(Boolean).join(" · ")}</span>{responsavel && <><br /><span style={{ color: "#71717A", fontSize: "0.72rem" }}>{[responsavel.telefone, responsavel.email].filter(Boolean).join(" · ")}</span></>}</div>
        <div className="bdm-assinatura"><div className="bdm-linha-ass" />{contratante}<br /><span style={{ color: "#71717A", fontSize: "0.72rem" }}>Aceite do cliente · data ___/___/______</span></div>
      </div>
    </div>
  );
}

function Cat({ cat, itens }) {
  const sub = itens.reduce((s, i) => s + (i.valor_total ?? (i.qtd_contratada || 0) * (i.preco_unitario || 0)), 0);
  return (
    <>
      <tr><td colSpan={6} style={{ background: "#FAFAFA", fontWeight: 700, fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>{cat}</td></tr>
      {itens.map((i, k) => (
        <tr key={i.id || k}>
          <td className="mono">{i.codigo}</td><td>{i.descricao}</td><td>{i.unidade}</td>
          <td style={{ textAlign: "right" }} className="mono">{fmt(i.qtd_contratada)}</td>
          <td style={{ textAlign: "right" }} className="mono">{formatCurrency(i.preco_unitario)}</td>
          <td style={{ textAlign: "right" }} className="mono">{formatCurrency(i.valor_total ?? (i.qtd_contratada || 0) * (i.preco_unitario || 0))}</td>
        </tr>
      ))}
      <tr><td colSpan={5} style={{ textAlign: "right", fontSize: "0.75rem", color: "#52525B" }}>Subtotal {cat}</td><td style={{ textAlign: "right" }} className="mono">{formatCurrency(sub)}</td></tr>
    </>
  );
}
